import { render, staticRenderFns } from "./PsnTaxBfEdit.vue?vue&type=template&id=2e49ba6a"
import script from "./PsnTaxBfEdit.vue?vue&type=script&lang=js"
export * from "./PsnTaxBfEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports